import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { TransactionAmount } from "../TransactionAmount";
import styles from "./OriginalAmountCell.module.scss";

export const OriginalAmountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, TransactionListItem, any>) => (
        <ViewTableCell>
            <TransactionAmount
                transaction={row.original}
                addSign
                color
                useOriginalAmount
                className={styles.originalAmount}
            />
        </ViewTableCell>
    ),
);
OriginalAmountCell.displayName = "OriginalAmountCell";
